var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImpactC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 49,
    fill: "none",
    viewBox: "0 0 52 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#72A2D6",
    d: "M51.02 24.423c0 2.592-3.226 4.652-3.986 6.991-.76 2.34.583 5.987-.887 8.005-1.469 2.019-5.303 1.824-7.337 3.31-2.036 1.487-2.99 5.177-5.413 5.962-2.424.785-5.295-1.647-7.887-1.647-2.593 0-5.54 2.407-7.887 1.647-2.348-.76-3.378-4.492-5.413-5.962-2.035-1.469-5.852-1.266-7.338-3.31-1.486-2.043-.093-5.573-.886-8.005C3.192 28.982 0 27.014 0 24.423c0-2.593 3.226-4.653 3.986-6.992.76-2.34-.583-5.987.886-8.005 1.47-2.018 5.303-1.824 7.338-3.31C14.245 4.629 15.2.939 17.623.154c2.424-.785 5.294 1.689 7.887 1.689 2.592 0 5.54-2.407 7.887-1.689 2.347.718 3.377 4.492 5.413 5.962 2.034 1.469 5.851 1.266 7.337 3.31 1.487 2.043.093 5.573.887 8.005.794 2.432 3.986 4.4 3.986 6.992Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 24,
    r: 17,
    fill: "#fff",
    stroke: "#72A2D6",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#72A2D6",
    d: "M25.984 32.71c-2.547 0-4.5-.796-5.859-2.39-1.375-1.586-2.063-3.652-2.063-6.199 0-2.547.688-4.625 2.063-6.234 1.367-1.602 3.32-2.403 5.86-2.403 2.038 0 3.726.602 5.062 1.805 1.32 1.195 2.039 2.707 2.156 4.535H29.84c-.094-.984-.461-1.785-1.102-2.402-.648-.625-1.566-.938-2.754-.938-1.5 0-2.636.504-3.41 1.512-.765 1-1.148 2.375-1.148 4.125 0 1.758.383 3.125 1.148 4.102.774 1.008 1.91 1.511 3.41 1.511 1.141 0 2.028-.293 2.66-.879.649-.578 1.055-1.347 1.22-2.308h3.34c-.188 1.789-.923 3.262-2.204 4.418-1.29 1.164-2.96 1.746-5.016 1.746Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpactC);
export default __webpack_public_path__ + "static/media/ImpactC.37f5dafc.svg";
export { ForwardRef as ReactComponent };